// src/pages/logistica/UnidadesVenta.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function UnidadesVenta() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardandoUnidad, setGuardandoUnidad] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/logistica/unidades-venta');
      setFilas(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  function handleCambiar(unidad, valor) {
    setFilas((prev) => prev.map((f) => (f.unidad === unidad ? { ...f, piezas_por_unidad: valor } : f)));
  }

  async function handleGuardar(unidad) {
    const fila = filas.find((f) => f.unidad === unidad);
    try {
      setGuardandoUnidad(unidad);
      setMensaje(null);
      await api.put(`/api/logistica/unidades-venta/${encodeURIComponent(unidad)}`, { piezas_por_unidad: fila.piezas_por_unidad });
      setMensaje({ tipo: 'ok', texto: `✓ ${unidad} = ${fila.piezas_por_unidad} piezas.` });
      cargar();
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || `No se pudo guardar ${unidad}.` });
    } finally {
      setGuardandoUnidad(null);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  const pendientes = filas.filter((f) => f.sin_clasificar).length;

  return (
    <div style={styles.contenedor}>
      <h1 style={styles.titulo}>Unidades de Venta → Piezas</h1>
      <p style={styles.subtitulo}>
        "Caja N" y "Pieza" se convierten solas. El resto (tarimas, empaques especiales) necesita capturarse aquí una vez.
        {pendientes > 0 && <span style={styles.pendientesAviso}> {pendientes} unidad{pendientes === 1 ? '' : 'es'} sin clasificar.</span>}
      </p>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        {filas.map((f) => {
          const faltaClasificar = f.sin_clasificar;
          return (
            <div key={f.unidad} style={{ ...styles.fila, ...(faltaClasificar ? styles.filaPendiente : {}) }}>
              <div style={styles.unidadNombre}>{f.unidad}</div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <input
                  type="number"
                  step="0.01"
                  min="0.01"
                  placeholder="—"
                  value={f.piezas_por_unidad ?? ''}
                  onChange={(e) => handleCambiar(f.unidad, e.target.value)}
                  style={{ ...styles.input, ...(faltaClasificar ? styles.inputPendiente : {}) }}
                />
                <span style={styles.unidadTexto}>piezas</span>
                <button
                  onClick={() => handleGuardar(f.unidad)}
                  disabled={guardandoUnidad === f.unidad || !f.piezas_por_unidad}
                  style={styles.botonGuardar}
                >
                  {guardandoUnidad === f.unidad ? '...' : 'Guardar'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '560px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  pendientesAviso: { color: '#B23A48', fontWeight: 600 },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', display: 'flex', flexDirection: 'column', gap: '14px' },
  fila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px', paddingBottom: '14px', borderBottom: '1px solid #F0E9E0' },
  filaPendiente: { background: '#FDF3F1', margin: '0 -18px', padding: '10px 18px', borderRadius: '8px' },
  unidadNombre: { fontSize: '14px', fontWeight: 700, color: '#2A1830' },
  input: { width: '80px', padding: '7px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  inputPendiente: { borderColor: '#B23A48' },
  unidadTexto: { fontSize: '11px', color: '#8A7690' },
  botonGuardar: { padding: '6px 14px', fontSize: '12px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '6px', cursor: 'pointer' },
};